import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

type Props = {
  open: boolean;
  /** Server message (may include recovery hints). */
  detailMessage: string;
  onClose: () => void;
};

/**
 * Shown when a full table has a disconnected human seat and this browser’s player id
 * does not match that seat — i.e. another person/session is still tied to that chair.
 */
export function SeatHeldByOtherPlayerModal({ open, detailMessage, onClose }: Props) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      aria-labelledby="seat-held-dialog-title"
      aria-describedby="seat-held-dialog-desc"
      PaperProps={{
        sx: {
          backgroundColor: "rgba(22, 22, 32, 0.98)",
          border: "1px solid rgba(255,255,255,0.12)",
          color: "rgba(255,255,255,0.92)",
        },
      }}
    >
      <DialogTitle id="seat-held-dialog-title" sx={{ fontWeight: 700 }}>
        This seat belongs to another player
      </DialogTitle>
      <DialogContent id="seat-held-dialog-desc">
        <Typography variant="body1" sx={{ mb: 1.5, lineHeight: 1.5 }}>
          A different human is still registered in that chair (another browser tab, device, or session).
          Your join cannot replace them unless you use the same table identity or the host frees the seat.
        </Typography>
        {detailMessage.trim().length > 0 && (
          <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.65)", lineHeight: 1.45 }}>
            {detailMessage}
          </Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} variant="contained" color="primary" autoFocus>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}
